import React, { FC } from "react";
import { Skeleton } from "antd";
import PatientDetailsForm from "./PatientDetailsForm";
import { PatientDetailsProps } from "../../props/PatientDetailsProps";

const PatientDetails: FC<PatientDetailsProps> = (props) => {
  return (
    <>
      {(props?.isFetchingPatient || props?.isFetchingStepperData) ? (
        <Skeleton active paragraph={{ rows: 10 }} />
      ) : props?.error !== "" ? (
        <>
          <PatientDetailsForm
            flag={props?.flag}
            selectedPatient={props?.selectedPatient}
            readOnly={props?.readOnly}
            toggleReadOnly={props?.toggleReadOnly}
            upDateDetails={props?.upDateDetails}
            calculateAge={props?.calculateAge}
            selectedHospital={props?.selectedHospital}
            isLoading={props?.isLoading}
            justify={props?.justify}
            clearReferralDetails={props?.clearReferralDetails}
            closeDeficiencyModal={props?.closeDeficiencyModal}
            deficiencyModal={props?.deficiencyModal}
            handleDownloadDocument={props?.handleDownloadDocument}
            isDownloadingDocument={props?.isDownloadingDocument}
            deficiencyQuestions={props?.deficiencyQuestions}
            selectedDocument={props?.selectedDocument}
            previewDocumentUrl={props?.previewDocumentUrl}
            handleDeficiencyModal={props?.handleDeficiencyModal}
            handleOpen={props?.handleOpen}
            showDoc={props?.showDoc}
            handleDoctorSearch={props?.handleDoctorSearch}
            availableDoctor={props?.availableDoctor}
            searchLoading={props?.searchLoading}
            handleNavigate={props?.handleNavigate}
            handleCreditClickModal={props?.handleCreditClickModal}
            handleUpdatePatientScheme={props?.handleUpdatePatientScheme}
            handleUpdatePatientDetails={props?.handleUpdatePatientDetails}
            showModal={props?.showModal}
            previewDocument={props?.previewDocument}
            setPreviewDocument={props?.setPreviewDocument}
            documentUrl={props?.documentUrl}
            zoomLevel={props?.zoomLevel}
            handleZoomIn={props?.handleZoomIn}
            handleZoomOut={props?.handleZoomOut}
            handleCancelPreview={props?.handleCancelPreview}
            getFileType={props?.getFileType}
            fetchStepper={props?.fetchStepper}
            handleActivateDeactivate={props?.handleActivateDeactivate}
            isActiveDeactiveModal={props?.isActiveDeactiveModal}
            setIsActiveDeactiveModal={props?.setIsActiveDeactiveModal}
            handleCancelConfirmationModal={props?.handleCancelConfirmationModal}
            handleOk={props?.handleOk}
            isSubmitting={props?.isSubmitting}
            newSteps={props?.newSteps}
            handleCreateEnhancement={props?.handleCreateEnhancement}
            handleCreateQuery={props?.handleCreateQuery}
            viewAddedEnhancement={props?.viewAddedEnhancement}
            handleSetActiveStage={props?.handleSetActiveStage}
            handleResubmission={props?.handleResubmission}
            viewResubmission={props?.viewResubmission}
            handleCreateUnlistedProcedure={props?.handleCreateUnlistedProcedure}
            handleCreateExtensionOfStay={props?.handleCreateExtensionOfStay}
            viewUnlistedProcedure={props?.viewUnlistedProcedure}
            viewExtensionOfStay={props?.viewExtensionOfStay}
          />
          {/* <Tabs onChange={props?.onTabChange} type="card" items={tabItems} /> */}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default PatientDetails;
